import { render } from "./SideRightMain.vue?vue&type=template&id=778f350d&scoped=true"
import script from "./SideRightMain.vue?vue&type=script&lang=js"
export * from "./SideRightMain.vue?vue&type=script&lang=js"

import "./SideRightMain.vue?vue&type=style&index=0&id=778f350d&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778f350d"]])

export default __exports__